import { Component } from 'react'
import { connect } from 'react-redux'

import { FormButtonGroup } from 'components/forms'
import { InfoButton } from 'components/buttons'
import { MultiStepWizard } from 'components/presentation'

import { saveRegistry, setActiveModal } from 'registry/actions'

import * as blUrls from 'lib/urls'

const InternationalUserForm = (props) => {
  return (
    <div className="text-center">
      <div className="h4 mtn mbxl lh-base">
        It looks like you are located outside the United States. Is that right?
      </div>
      <FormButtonGroup
        submit={false}
        textPrimary="Yes"
        textSecondary="No"
        onClickPrimary={props.onConfirmLocation}
        onClickSecondary={() => {
          props
            .saveRegistry({
              registry: {
                id: props.registry.id,
                shippingAddress: { country: 'United States' },
              },
            })
            .then(() => props.setActiveModal(null))
        }}
      />
      <p className="mtxl h6">
        To improve your Babylist experience, we will only show features that are
        available to customers outside the United States.
      </p>
    </div>
  )
}

const InternationalUserConfirmation = (props) => {
  return (
    <div>
      <p className="text-bold">
        Here are some tips on how to best use Babylist outside of the United
        States:
      </p>
      <ul className="list-unstyled mbxl">
        <li className="mbm">
          - Don't add items to your registry from the Babylist shop. We
          currently only ship items within the United States.
        </li>
        <li>
          - Use the{' '}
          <a href={blUrls.addItemsPath} target="_blank">
            Babylist button
          </a>{' '}
          to add items from stores that can ship to you.
        </li>
      </ul>
      <div className="text-center">
        <InfoButton onClick={() => props.setActiveModal(null)}>
          Close
        </InfoButton>
      </div>
    </div>
  )
}

class InternationalUserContainer extends Component {
  state = {
    activeStep: 1,
  }

  render() {
    return (
      <MultiStepWizard activeStep={this.state.activeStep} animateInitialStep>
        <InternationalUserForm
          onConfirmLocation={() => this.setState({ activeStep: 2 })}
          {...this.props}
        />
        <InternationalUserConfirmation {...this.props} />
      </MultiStepWizard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    registry: state.registry,
  }
}
export default connect(mapStateToProps, {
  saveRegistry,
  setActiveModal,
})(InternationalUserContainer)
